/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './hardware-entities.scss';

/*@ngInject*/
export default function HardwareEntitiesController($translate, $mdDialog, gatewayService, gatewayModelService, gatewayGroupService,
                                                   providerService) {
    var vm = this;

    vm.$onInit = function () {
        vm.entityStateText = '';

        vm.gatewayInputMac = '';
        vm.gatewayEntity = {};
        vm.deviceInputEui = '';
        vm.deviceEntity = {};

        vm.getGatewayByMac = getGatewayByMac;
        vm.deleteGateway = deleteGateway;
    };

    function getGatewayByMac() {
        if (vm.gatewayInputMac) {
            var gatewayPromise = gatewayService.getSystemGatewayByMac(vm.gatewayInputMac);
            if (gatewayPromise) {
                gatewayPromise.then(
                    (gateway) => {
                        if (!angular.equals('', gateway)) {
                            vm.entityStateText = '';

                            vm.gatewayEntity.id = gateway.id.id;
                            vm.gatewayEntity.name = gateway.name;
                            getGatewayModelName(gateway.gatewayModelId.id);
                            vm.gatewayEntity.mac = gateway.mac;
                            getGatewayGroupName(gateway.gatewayGroupId.id);
                            getProviderName(gateway.providerId.id);
                            vm.gatewayEntity.customerName = gateway.customerTitle;
                        } else {
                            resetEntityState($translate.instant('hardware-entities.gateway-not-found-text', {mac: vm.gatewayInputMac}));
                        }
                    },
                    () => {
                        resetEntityState($translate.instant('hardware-entities.gateway-not-found-text', {mac: vm.gatewayInputMac}));
                    });
            }
        }
    }

    function deleteGateway($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title($translate.instant('gateway.delete-gateway-title', {name: vm.gatewayEntity.name}))
            .htmlContent($translate.instant('gateway.delete-gateway-text'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
                gatewayService.deleteSystemGateway(vm.gatewayEntity.id).then(function success() {
                    vm.gatewayInputMac = '';
                    resetEntityState($translate.instant('hardware-entities.gateway-was-deleted', {mac: vm.gatewayEntity.mac}));
                })
            },
            function () {
            })
    }

    function getGatewayModelName(gatewayModelId) {
        var gatewayModelPromise = gatewayModelService.getSystemGatewayModel(gatewayModelId);
        if (gatewayModelPromise) {
            gatewayModelPromise.then(
                (gatewayModel) => {
                    vm.gatewayEntity.modelName = gatewayModel.name;
                },
                () => {
                    vm.gatewayEntity.modelName = '';
                }
            );
        }
    }

    function getGatewayGroupName(gatewayGroupName) {
        var gatewayGroupPromise = gatewayGroupService.getSystemGatewayGroup(gatewayGroupName);
        if (gatewayGroupPromise) {
            gatewayGroupPromise.then(
                (gatewayGroup) => {
                    vm.gatewayEntity.groupName = gatewayGroup.name;
                },
                () => {
                    vm.gatewayEntity.groupName = '';
                }
            );
        }
    }

    function getProviderName(providerId) {
        var providerServicePromise = providerService.getProvider(providerId);
        if (providerServicePromise) {
            providerServicePromise.then(
                (provider) => {
                    vm.gatewayEntity.providerName = provider.name;
                    vm.deviceEntity.providerName = provider.name;
                },
                () => {
                    vm.gatewayEntity.providerName = '';
                    vm.deviceEntity.providerName = '';
                }
            );
        }
    }

    function resetEntityState(stateText) {
        vm.entityStateText = stateText;
        vm.gatewayEntity = {};
        vm.deviceEntity = {};
    }
}



// WEBPACK FOOTER //
// ./src/app/hardware-entities/hardware-entities.controller.js